import { Box } from '@mui/material';

export default function PageWrapperBox({children, sx}) {
    return <Box position="relative" sx={{mt: '5px', pb: '20px'}}> 

            <Box sx={{height: '40px', width: '100%', backgroundColor: (theme) => theme.palette.primary.main, position:"absolute", bottom: 0, zIndex: 0, borderBottomLeftRadius: 40, borderBottomRightRadius: 40}}></Box>

            <Box sx={{
                pt: 3, pb: 3, px: 3, 
                borderRadius: '20px', 
                mx: '20px',
                
                position: 'absolute',
                transform: 'translate(0, calc(-100% + 0px))',
                width: "calc(100% - 40px)", 
                backgroundColor: "white",
                ...sx
                }}>

            {children}


            </Box>  
        </Box>
}   